import { RefObject } from 'react';

const handleEscapePress = ({ key }: KeyboardEvent, event: Function) => {
  if (key === 'Escape') {
    event();
  }
};

/**
 * Esta função executa uma função passada por parâmetro, sempre que o usuário clicar fora do componente informado pela REF, ou pressionar a tecla ESCAPE(ESC)
 * @param ref Informe o referência do elemento HTML
 * @param event Informe a função que será executada
 */
export const handleClosePopUp = (ref: RefObject<any>, event: Function) => {
  const handleClickOutside = ({ target }: Event) => {
    if (ref.current && !ref.current.contains(target as Node)) {
      event();
    }
  };

  document.addEventListener('keydown', (e) => handleEscapePress(e, event), true);
  document.addEventListener('click', handleClickOutside, true);

  return () => {
    document.removeEventListener('keydown', (e) => handleEscapePress(e, event), true);
    document.removeEventListener('click', handleClickOutside, true);
  };
};

/**
 * Esta função executa uma função passada por parâmetro, sempre que o usuário pressionar a tecla ESCAPE(ESC)
 * @param event Informe a função que será executada
 */
export const handleCloseEscape = (event: Function) => {
  document.addEventListener('keydown', (e) => handleEscapePress(e, event), true);

  return () => {
    document.removeEventListener('keydown', (e) => handleEscapePress(e, event), true);
  };
};
